import * as React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './NewPasswordFailed.css';

export default class NewPasswordFailed extends React.PureComponent {
    public render() {
        return (
            <>
                <HeaderLoggedOut />
                <Container id="newPasswordFailedView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.newPasswordFailed_failed}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.newPasswordFailed_outdated}
                            <br />
                            <Link className="btn mt-3" to="/">
                                {TR.newPasswordFailed_to_login}
                            </Link>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/newPasswordFailed/NewPasswordFailed.tsx